// client/src/hooks/useExchangeRates.js
import { useQuery } from '@tanstack/react-query';
import { fetchExchangeRates } from '../services/currency.service';

/**
 * Hook que obtiene y cachea globalmente las tasas de cambio usando react-query.
 * @param {string} baseCurrency - La moneda base a consultar.
 * @returns {object} - El resultado de la query de react-query.
 */
export const useExchangeRates = (baseCurrency = 'USD') => {
  return useQuery({
    // La clave de la query incluye la moneda base para cachear diferentes monedas si es necesario.
    queryKey: ['exchangeRates', baseCurrency],
    // La función que se ejecutará para obtener los datos.
    queryFn: () => fetchExchangeRates(baseCurrency),
    // Configuración de caché: consideramos las tasas válidas por 4 horas.
    // react-query no volverá a hacer una llamada a la API durante este tiempo.
    staleTime: 1000 * 60 * 60 * 4,
    // Mantiene los datos en caché por más tiempo.
    cacheTime: 1000 * 60 * 60 * 24,
    // Evita reintentos en caso de error para no gastar cuota de la API.
    retry: 1,
  });
};
